<template>
  <div class="lora-info">
    <PageHeading title="LoRa Info" />
    <PageContent>
      <LoraInfoCollection :items="items" />
    </PageContent>
    <Pager
      :is-first-page
      :is-last-page
      :current-page
      :page-count
      @prev="prev"
      @next="next"
      @page-select="onPageSelect"
    />
  </div>
</template>

<script setup lang="ts">

const appConfig = useAppConfig()

const items = ref([])
const total = ref(0)
const pageSize = 12

const { start, finish } = useLoadingIndicator()

const {
  currentPage,
  pageCount,
  isFirstPage,
  isLastPage,
  prev,
  next,
  offset,
  onPageSelect
} = await usePaginatedFilteredQuery(total, pageSize, fetchData, ref({}))

async function fetchData (setData: Boolean = true) {
  start()
  return await useGraphqlQuery('loraInfo', {
    limit: pageSize,
    offset: offset.value
  }).then((v) => {
    // @todo: refactor this: move to usePaginatedFilteredQuery?
    if (setData) {
      items.value = v.data.info.items
      total.value = v.data.info.total
    }
    finish()
    return v.data.info
  })
}

const { data } = await useAsyncData('loraInfo', async () => {
  return await fetchData(false)
})

items.value = data.value.items
total.value = data.value.total

useSeoMeta({
  title: 'LoRa-Info'
})

</script>
